import React from 'react';
import { cn } from '@/lib/utils';

interface ProgressBarProps {
  /** 0 to 1. */
  value: number;
  tone?: 'brand' | 'info' | 'success';
  /** Accessible description, e.g. "Cover remaining". */
  label: string;
  className?: string;
}

/** 6px linear progress track. */
const ProgressBar: React.FC<ProgressBarProps> = ({ value, tone = 'brand', label, className }) => {
  const pct = Math.round(Math.min(1, Math.max(0, value)) * 100);
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      className={cn('tw-h-1.5 tw-w-full tw-overflow-hidden tw-rounded-[3px] tw-bg-ds-border-default', className)}
    >
      <div
        className={cn('tw-h-full tw-rounded-[3px]', { brand: 'tw-bg-ds-brand', info: 'tw-bg-ds-info-fg', success: 'tw-bg-ds-success-fg' }[tone])}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

export default ProgressBar;
